import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpRequest, HttpParams, HttpHeaders, HttpEvent } from '@angular/common/http';
import { AuthenticationService } from '../auth';
import { Globals } from '../globals';
import { Cookie } from 'ng2-cookies';
import { Observable } from 'rxjs';

@Injectable()
export class ImportRKImageService implements OnInit {

    constructor(private http: HttpClient, private authService: AuthenticationService, private globals: Globals) { }

    ngOnInit() : void {
        this.authService.isTokenValid();
    }


    deleteFile(file: File) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/import/file/' + file.name;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.delete(url, {headers: requestHeaders, responseType: 'text'})
    }

    /**
     * Upload a file to be parsed with OCR
     * @file fil
     */
    upload(file : FormData) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/import/';
        let requestHeaders = new HttpHeaders()
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const req = new HttpRequest('POST', url, file, {
          headers: requestHeaders,
          reportProgress: true,
          responseType: 'text'
        });

        return this.http.request(req);
    }

    /**
     * Initiate OCR reading for a file
     * @file fil
     */
    startOCR(fileName : String) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/import/startOCR/' + fileName;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'text'})
    }

    /**
     * Initiate pdf reading for a file
     * @file fil
     */
    startPDF(fileName : String) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/import/startPDF/' + fileName;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'text'})
    }


    /*
    * Upload file to be reviewed
    * @param file the file to be uploaded
    */
    uploadXML(file: File) : Observable<HttpEvent<{}>> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/import/uploadXML/';
        let requestHeaders = new HttpHeaders()
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());
        let XMLfile: FormData = new FormData();
        XMLfile.append('XMLfile', file);
        const req = new HttpRequest('POST', url, XMLfile, {
          headers: requestHeaders,
          reportProgress: false,
          responseType: 'json'
        });
        return this.http.request(req);
    }
    
    /*
    * Upload xml file and check if it has been applied before
    * @param file the file to be uploaded
    */
    checkExists(file: File) : Observable<HttpEvent<{}>> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/import/xml/checkExists/';
        let requestHeaders = new HttpHeaders()
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());
        let XMLfile: FormData = new FormData();
        XMLfile.append('XMLfile', file);
        const req = new HttpRequest('POST', url, XMLfile, {
          headers: requestHeaders,
          reportProgress: false,
          responseType: 'json'
        });
        return this.http.request(req);
    }

    /*
    * Download the return excel file as a stream
    * @param uuid ExportData identifier 
    * @param type the ExportData type
    */
    getExcelStream(uuid, type) {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/import/showSapoExcel/' + uuid;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());
        return this.http.get(url, {headers: requestHeaders, responseType: 'blob'}) 
    }  

    saveNewPerson(person) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/person/saveAndImport/';
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams()
        .set('personBody', JSON.stringify(person));

        return this.http.post(url, body, {observe: "response", headers: requestHeaders, responseType: "json"});
    }
}
